
import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { BtnStyleTypes } from 'libraries/ui_button/btn.component';
import { Yii } from 'libraries/interfaces/Yii';
import { NotificationType } from 'libraries/interfaces/INotification';

@Component({
    selector: 'rate-invalidity-notification',
    template: `
        <notification *ngIf="!isXRateValid"
            [type]="notificationType">
            <span class="notification-body">
                <p>{{xRateInvalidityNotificationMessage}}</p>
                <btn [label]="xRateRefreshButton.label"
                    [type]="xRateRefreshButton.type"
                    (click)="refreshRates()">
                </btn>
            </span>
        </notification>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
        .notification-body{
            display: flex;
            justify-content: space-between;
        }
    `]
})

export class RateInvalidityNotificationComponent implements OnChanges{

    @Input()
    public readonly isXRateValid: boolean = true;

    @Input()
    public readonly hasFoundValidRate: boolean = true;

    @Output()
    public readonly onRefreshRates: EventEmitter<null> = new EventEmitter<null>();

    public notificationType: string;
    public xRateInvalidityNotificationMessage: string = getNotificationMessage(this.hasFoundValidRate);
    public readonly xRateRefreshButton: { label: string; type: BtnStyleTypes } = {
        label: Yii.t('wui-quotation-js', 'Rafraichir les prix'),
        type: BtnStyleTypes.action
    };

    public ngOnChanges(simpleChanges: SimpleChanges): void{
        if (simpleChanges.hasFoundValidRate &&
            !simpleChanges.hasFoundValidRate.previousValue ||
            (simpleChanges.hasFoundValidRate && simpleChanges.hasFoundValidRate.previousValue &&
            simpleChanges.hasFoundValidRate.currentValue !== simpleChanges.hasFoundValidRate.previousValue)
        ){
            this.notificationType = getNotificationType(this.hasFoundValidRate);
            this.xRateInvalidityNotificationMessage = getNotificationMessage(this.hasFoundValidRate);
        }
    }

    public refreshRates(): void {
        this.onRefreshRates.emit();
    }
}

function getNotificationMessage(hasFoundValidRate: boolean): string{
    return hasFoundValidRate ?
        Yii.t('wui-quotation-js', 'Les taux de change ont changé et ne sont plus valides') :
        Yii.t('wui-quotation-js', "Aucun taux de change valide n'a été trouvé. Les prix de la cotation n'ont donc pas changé. De nouveaux taux de change valides doivent être configurés")
}

function getNotificationType(hasFoundValidRate: boolean): string{
    return hasFoundValidRate ?
        NotificationType.Warning :
        NotificationType.Info;
}
